var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19814_8340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#008fed"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19814_8340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 13.3333C9.76405 13.3333 9.56627 13.2533 9.40683 13.0933C9.24683 12.9339 9.16683 12.7361 9.16683 12.5V6.54167L7.60433 8.10417C7.43766 8.27083 7.24322 8.35417 7.021 8.35417C6.79877 8.35417 6.59738 8.26389 6.41683 8.08333C6.25016 7.91667 6.17044 7.71861 6.17766 7.48917C6.18433 7.26028 6.26405 7.06944 6.41683 6.91667L9.41683 3.91667C9.50016 3.83333 9.59044 3.77417 9.68766 3.73917C9.78488 3.70472 9.88905 3.6875 10.0002 3.6875C10.1113 3.6875 10.2154 3.70472 10.3127 3.73917C10.4099 3.77417 10.5002 3.83333 10.5835 3.91667L13.5835 6.91667C13.7502 7.08333 13.8299 7.28111 13.8227 7.51C13.816 7.73944 13.7363 7.93056 13.5835 8.08333C13.4168 8.25 13.2191 8.33667 12.9902 8.34333C12.7607 8.35056 12.5627 8.27083 12.396 8.10417L10.8335 6.54167V12.5C10.8335 12.7361 10.7538 12.9339 10.5943 13.0933C10.4343 13.2533 10.2363 13.3333 10.0002 13.3333ZM5.00016 16.6667C4.54183 16.6667 4.14961 16.5036 3.8235 16.1775C3.49683 15.8508 3.3335 15.4583 3.3335 15V13.3333C3.3335 13.0972 3.41322 12.8992 3.57266 12.7392C3.73266 12.5797 3.93072 12.5 4.16683 12.5C4.40294 12.5 4.601 12.5797 4.761 12.7392C4.92044 12.8992 5.00016 13.0972 5.00016 13.3333V15H15.0002V13.3333C15.0002 13.0972 15.0802 12.8992 15.2402 12.7392C15.3996 12.5797 15.5974 12.5 15.8335 12.5C16.0696 12.5 16.2674 12.5797 16.4268 12.7392C16.5868 12.8992 16.6668 13.0972 16.6668 13.3333V15C16.6668 15.4583 16.5038 15.8508 16.1777 16.1775C15.851 16.5036 15.4585 16.6667 15.0002 16.6667H5.00016Z",
    fill: "#008fed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.398d8d84557d4eff5213af7cf03f3acd.svg";
export { ForwardRef as ReactComponent };